// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3ADyo";
var _4 = "notifications-1Y6Xa";
var _5 = "pricesDetailsWrapper-7qkZo";
var _6 = "pricesNotification-29HAU";
var _7 = "pricesNotification__context-IauTv";
var _8 = "pricesNotification__icon-2xekL";
var _9 = "pricesNotification__text-2otV4";
var _a = "refundSummary-ziyGz";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "notifications", _5 as "pricesDetailsWrapper", _6 as "pricesNotification", _7 as "pricesNotification__context", _8 as "pricesNotification__icon", _9 as "pricesNotification__text", _a as "refundSummary" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "notifications": _4, "pricesDetailsWrapper": _5, "pricesNotification": _6, "pricesNotification__context": _7, "pricesNotification__icon": _8, "pricesNotification__text": _9, "refundSummary": _a }
